import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center mb-2" }
const _hoisted_2 = { class: "" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "badge badge-info mr-2" }, "#", -1)
const _hoisted_4 = { class: "badge bg-warning text-dark" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_link = _resolveComponent("b-link")!
  const _component_b_badge = _resolveComponent("b-badge")!
  const _component_b_card_text = _resolveComponent("b-card-text")!
  const _component_b_card = _resolveComponent("b-card")!
  const _component_b_overlay = _resolveComponent("b-overlay")!

  return (_openBlock(), _createBlock(_component_b_overlay, {
    show: _ctx.load,
    rounded: "sm"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_b_card, {
        class: "shadow-sm",
        title: _ctx.$t('actualities.title')
      }, {
        default: _withCtx(() => [
          _createVNode(_component_b_card_text, { style: {"min-height":"140px"} }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.actualites, (post, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "w-100",
                  key: index
                }, [
                  _createElementVNode("div", _hoisted_1, [
                    _createVNode(_component_b_link, {
                      target: "_blanck",
                      href: post.link
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("h6", _hoisted_2, [
                          _hoisted_3,
                          _createTextVNode(" " + _toDisplayString(post.title), 1)
                        ])
                      ], undefined, true),
                      _: 2
                    }, 1032, ["href"]),
                    (_ctx.user.admin)
                      ? (_openBlock(), _createBlock(_component_b_link, {
                          key: 0,
                          class: "ml-auto",
                          target: "_blank",
                          href: _ctx.siteBaseURl + '/wp-admin/post.php?post=' + _ctx.getPostID(post.guid) + '&action=edit'
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('actualities.editButton')), 1)
                          ], undefined, true),
                          _: 2
                        }, 1032, ["href"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_b_badge, {
                      variant: "primary",
                      class: _normalizeClass([_ctx.user.admin ? '' : 'ml-auto', "ml-2"])
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$filters.calendar(post.pubDate)), 1)
                      ], undefined, true),
                      _: 2
                    }, 1032, ["class"])
                  ])
                ]))
              }), 128))
            ], undefined, true),
            _: 1
          })
        ], undefined, true),
        _: 1
      }, 8, ["title"])
    ], undefined, true),
    _: 1
  }, 8, ["show"]))
}